export default __webpack_public_path__ + "static/banner-devops-c628646c404a5ed7c7f435cf6332a3a5.jpg";